import React from "react";

import { number, func } from "prop-types";

import Icon from "../../Icon/Icon.jsx";

const propTypes = {
  currentPage: number,
  totalPages: number,
  onClickPrev: func,
  onClickNext: func,
};

const SliderNavigation = (props) => {
  const { currentPage, totalPages, onClickPrev, onClickNext } = props;

  const formatPagination = () => {
    const current =
      currentPage !== totalPages
        ? (currentPage + 1).toString().padStart(2, "0")
        : currentPage + 1;

    const total = totalPages - 1 < 9 ? `0${totalPages}` : totalPages;

    return `${current} / ${total}`;
  };

  return (
    <div className="card-slider-navigation">
      <button
        type="button"
        className="btn card-slider-navigation__prev"
        onClick={onClickPrev}
      >
        <Icon iconName="arrow-left" />
        <span>Previous</span>
      </button>
      <span className="card-slider-navigation__pagination">
        {formatPagination()}
      </span>
      <button
        type="button"
        className="btn card-slider-navigation__next"
        onClick={onClickNext}
      >
        <span>Next</span>
        <Icon iconName="arrow-right" />
      </button>
    </div>
  );
};

SliderNavigation.propTypes = propTypes;

export default SliderNavigation;
